export default __webpack_public_path__ + "static/media/SUR.07a31e52.svg";